<template>
  <v-form lazy-validation @submit.prevent ref="form">
    <v-row justify="center">
      <h2>
        <vue-typer
          text="Objednaj si upratovanie!"
          :repeat="0"
          :pre-type-delay="1500"
        />
      </h2>
    </v-row>
    <choose-building
      @change="changeHandler('building', 'block', $event)"
      :used="building"
    />
    <v-scale-transition>
      <choose-block
        @change="changeHandler('block', 'flatId', $event)"
        :building="building"
        v-show="building"
        ref="block"
        :used="block"
      />
    </v-scale-transition>

    <v-scale-transition>
      <flat-id
        :block="block"
        @change="changeHandler('flatId', 'date', $event)"
        v-show="block"
        ref="flatId"
      />
    </v-scale-transition>

    <v-scale-transition>
      <choose-date
        @change="changeHandler('date', 'time', $event)"
        :flatId="flatId"
        v-show="flatId"
        ref="date"
      />
    </v-scale-transition>

    <v-scale-transition>
      <choose-time
        @change="changeHandler('time', 'cleaningType', $event)"
        :date="date"
        v-show="date"
        ref="time"
      />
    </v-scale-transition>

    <v-scale-transition>
      <cleaning-type
        @change="changeHandler('cleaningType', 'choosePerson', $event)"
        :time="time"
        v-show="time"
        ref="cleaningType"
      />
    </v-scale-transition>

    <v-scale-transition>
      <choose-person
        v-if="time"
        ref="choosePerson"
        @order="changeHandler('choosePerson', 'userInfo', $event)"
        v-show="cleaningType"
        :time="time"
      />
    </v-scale-transition>

    <v-scale-transition>
      <picked-person
        ref="pickedPerson"
        v-show="choosePerson"
        :pickedPerson="choosePerson"
      />
    </v-scale-transition>

    <v-scale-transition>
      <user-info
        v-show="choosePerson"
        ref="userInfo"
        @change="changeHandler('userInfo', 'orderConfirmation', $event)"
        :refForm="$refs.form"
      />
    </v-scale-transition>

    <v-scale-transition>
      <order-confirmation
        v-show="userInfo"
        :orderInfo="!!userInfo && orderInfo"
        :allDone="!!userInfo"
        ref="orderConfirmation"
        :refForm="$refs.form"
      />
    </v-scale-transition>
  </v-form>
</template>

<script>
import ChooseBlock from "./formComponents/ChooseBlock";
import ChooseBuilding from "./formComponents/ChooseBuilding";
import ChooseDate from "./formComponents/ChooseDate";
import ChoosePerson from "./formComponents/ChoosePerson.vue";
import ChooseTime from "./formComponents/ChooseTime.vue";
import CleaningType from "./formComponents/CleaningType.vue";
import UserInfo from "./formComponents/UserInfo.vue";
import FlatId from "./formComponents/FlatId.vue";
import PickedPerson from "./formComponents/PickedPerson.vue";
import { VueTyper } from "vue-typer";
import OrderConfirmation from "./formComponents/OrderConfirmation.vue";

export default {
  name: "CleanForm",
  components: {
    ChooseBlock,
    ChooseBuilding,
    FlatId,
    ChooseDate,
    ChooseTime,
    UserInfo,
    CleaningType,
    ChoosePerson,
    VueTyper,
    OrderConfirmation,
    PickedPerson
  },
  data: () => ({
    building: "",
    block: null,
    flatId: null,
    date: null,
    time: null,
    cleaningType: null,
    choosePerson: null,
    price: null,
    userInfo: null,
  }),
  methods: {
    changeHandler(prop, toScroll, newValue) {
      if (!newValue) return;
      let off_set = 170;
      if (
        toScroll === "date" ||
        toScroll === "userInfo" ||
        toScroll === "orderConfirmation"
      )
        off_set = 0;
      let propToChange = eval("this." + prop);
      let scroll = !propToChange;
      propToChange = newValue;
      eval(`this.${prop} = newValue`);
      if (scroll) {
        let scrollEl = eval(`this.$refs.${toScroll}`);
        this.$nextTick(() => {
          this.$vuetify.goTo(scrollEl, {
            offset: off_set,
            easing: "easeInOutCubic",
            duration: 1000
          });
        });
      }
    }
  },
  computed: {
      orderInfo() {
        return {
          building: this.building,
          block: this.block,
          flatId: this.flatId,
          date: this.date,
          choosePerson: this.choosePerson,
          cleaningType: this.cleaningType,
          price: this.price,
          userInfo: this.userInfo,
          term: this.choosePerson.term,
        }
      }
    }
}
</script>
<style>
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #002 !important;
  border: none;
}
.theme--light.v-btn.v-btn--disabled {
  color: white !important;
}
</style>
